<template>
  <div
    :class="{ 'is-loading': loading }"
    :style="wrapperStyle"
  >
    <div
      class="preloader-component"
      v-if="loading"
      :style="loaderStyle"
    >
      <div class="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    minHeight: {
      type: [String, Number],
      default: null,
    },
    maxHeight: {
      type: [String, Number],
      default: null,
    },
    top: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    wrapperStyle() {
      return {
        position: "relative",
        ...(this.minHeight ? { minHeight: this.addUnit(this.minHeight) } : {}),
        ...(this.maxHeight ? { maxHeight: this.addUnit(this.maxHeight) } : {}),
      };
    },
    loaderStyle() {
      return {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        ...(this.top != null
          ? { alignItems: "flex-start", paddingTop: this.addUnit(this.top) }
          : { alignItems: "center" }),
        ...(this.minHeight ? { minHeight: this.addUnit(this.minHeight) } : {}),
        ...(this.maxHeight ? { maxHeight: this.addUnit(this.maxHeight) } : {}),
      };
    },
  },
  methods: {
    addUnit(value) {
      return typeof value === "number" ? `${value}px` : value;
    },
    loaderclose() {
      const preloader = document.getElementsByClassName("preloader-component");
      Array.prototype.forEach.call(preloader, (el) => {
        el.style.display = "none";
      });
      const status = document.getElementsByClassName("status");
      Array.prototype.forEach.call(status, (el) => {
        el.style.display = "none";
      });
    },
    loaderopen() {
      const preloader = document.getElementsByClassName("preloader-component");
      Array.prototype.forEach.call(preloader, (el) => {
        el.style.display = "block";
      });
      const status = document.getElementsByClassName("status");
      Array.prototype.forEach.call(status, (el) => {
        el.style.display = "block";
      });
    },
  },
};
</script>
